/* eslint-disable no-unused-vars */
import $ from 'jquery';
import * as _ from 'lodash';
import { fabric } from '../common/fabric';
import { ui } from '../common/ui';
import { util } from '../common/util';
import { api } from '../common/api';
import { places } from './places';
import { client } from './client_v2';
import { isIPad } from '../../utilities/commonUtil';
import { drawing } from '../common/drawing';

function _split() {
  this._canvas = [];
  this._splitRoomIds = [];
  this._roomIds = [];

  this._splitNumber = 0;

  this._splitWidthC = [0, 0, 499, 0, 499, 0, 333, 0, 0, 333];
  this._splitHeightC = [0, 0, 325, 0, 325, 0, 216, 0, 0, 216];
  this._splitZoom = [1, 1, 0.5, 1, 0.5, 1, 0.33, 1, 1, 0.33];

  this._orderBy = 'date';

  this._SPLIT_MAX = 9;

  this._splitInfo = [];

  this._places;
  this._placeId;
  this._placeName;

  this._date;

  this._page = 0;
  this._splited = false;
}

// 初期化
_split.prototype.init = function(id) {
  var self = this;

  for (let i = 0; i < self._SPLIT_MAX; i++) {
    self._canvas[i] = new fabric.StaticCanvas(`${id}-${i}`, {
      width: 500,
      height: 325,
    });
    self._splitRoomIds[i] = '';
  }
  self.setSplit(1, true);
  $('.btn-rail-navi, .btn-rail-master-navi').click(function() {
    setTimeout(() => {
      self.calcMultiSplit();
    }, 150);
  });
  $('.select_split_number').click(function() {
    self.calcMultiSplit();
  });

  window.addEventListener('orientationchange', () => {
    setTimeout(() => {
      self.calcMultiSplit();
    }, 150);
  });
};
// 分割設定
_split.prototype.setSplit = function(number, firstTimeAccessed) {
  var self = this;
  self._splitNumber = number;
  _.each($('.select_split_number'), function(select_split_number) {
    if ($(select_split_number).attr('data-id') == number) {
      $(select_split_number).addClass('selected');
    } else {
      $(select_split_number).removeClass('selected');
    }
  });

  // 分割画面表示/非表示 分割枠幅・高さを設定

  for (let i = 0; i < self._SPLIT_MAX; i++) {
    $('.layout-grid').removeClass(`grid-${i + 1}`);
    $(`.sys_cell_${i}`).css('min-width', self._splitWidthC[number] - 1);
    $(`.sys_cell_${i}`).css('min-height', self._splitHeightC[number] + 40);
    self._canvas[i].setWidth(self._splitWidthC[number] - 1);
    self._canvas[i].setHeight(self._splitHeightC[number]);
    self._canvas[i].setZoom(self._splitZoom[number]);
    var d = $(`.sys_cell_${i}`);
    if (i < number) {
      d.show();
    } else {
      d.hide();
    }
  }
  // 編集画面表示
  $('.layout-grid').addClass(`grid-${self._splitNumber}`);
  if (self._splitNumber >= 2) {
    $('.sys_cell_edit').hide();
    // データを読み込み
    self.reload();
  } else {
    $('.sys_cell_edit').show();
    $('.sys_cell_0').hide();
  }
  if (firstTimeAccessed) {
    drawing._zoom = 1;
  }
  if (self._splited && !firstTimeAccessed) {
    setTimeout(() => {
      $('#dropdown-zoom-level')
        .find('input')
        .val(`${drawing._zoom * 100}%`);
    }, 10);
  }
  self._splited = number !== 1;
};

// 分割画面データ読込
_split.prototype.reload = function() {
  var self = this;

  // 場所情報を取得
  self._places = places._placeList;

  // 基準場所（現在場所）を取得
  self._placeId = places._selectId;
  self._placeName = places._selectName;

  // 基準日（現在表示日）を取得
  self._date = ui.currentDate;

  // 頁位置を初期化
  self._page = 0;
  self.setPage();
};

// 頁位置設定
_split.prototype.setPage = async function(p) {
  var self = this;

  if (p) {
    self._page = self._page + p;
  }
  var offset = self._page * self._splitNumber;

  if (self._orderBy == 'date') {
    // 日付順の場合
    var sdate = self._date;
    var rev = 0;
    if (p == 0 && self._splitInfo[0] != undefined) {
      sdate = self._splitInfo[0].date;
      sdate.setDate(sdate.getDate());
    } else if (p == 1) {
      sdate = self._splitInfo[self._splitNumber - 1].date;
      sdate.setDate(sdate.getDate() + 1);
    } else if (p == -1) {
      sdate = self._splitInfo[0].date;
      sdate.setDate(sdate.getDate() - 1);
      rev = 1;
    }
    var prm = {
      date_str: util.dataFormat(sdate, 'YYYY/MM/DD'),
      count: self._splitNumber,
      reverse: rev,
    };

    const res = await api.getDatelist(prm);
    // console.log('result api.getDatelist', res);

    if (res.result) {
      let dates = res.data.entities.work_dates;
      if (p == -1) {
        dates = dates.reverse();
      }
      for (let i = 0; i < self._splitNumber; i++) {
        if (dates.length <= i) {
          self._splitInfo[i] = {
            room_id: '',
            date: '',
            place_id: self._placeId,
            name: '',
          };
        } else {
          var dt = new Date(dates[i]);
          self._splitInfo[i] = {
            room_id: util.getRoomId(self._placeId, dt),
            date: dt,
            place_id: self._placeId,
            name: self._placeName,
          };
        }
      }
      self.hideNaviPrev();
      self.hideNaviNext();

      // 読み込み処理
      for (let i = 0; i < self._splitNumber; i++) {
        self.loadData(i, self._splitInfo[i]);
      }
      setTimeout(function showButton() {
        self.showNaviPrev();
        self.showNaviNext();
      }, 500);
    }
  } else {
    // 場所順の場合
    for (let i = 0; i < self._splitNumber; i++) {
      if (self._places[i + offset] == undefined) {
        self._splitInfo[i] = {
          room_id: '',
          date: self._date,
          place_id: '',
          name: '',
        };
      } else {
        self._splitInfo[i] = {
          room_id: util.getRoomId(self._places[i + offset].id, self._date),
          date: self._date,
          place_id: self._places[i + offset].id,
          name: self._places[i + offset].name,
        };
      }
    }

    self.hideNaviPrev();
    self.hideNaviNext();

    // 読み込み処理
    for (let i = 0; i < self._splitNumber; i++) {
      self.loadData(i, self._splitInfo[i]);
    }

    setTimeout(function showButton() {
      if ((self._page + 1) * self._splitNumber < self._places.length) {
        self.showNaviNext();
      } else {
        self.hideNaviNext();
      }
      if (self._page != 0) {
        self.showNaviPrev();
      } else {
        self.hideNaviPrev();
      }
    }, 500);
  }
};

_split.prototype.loadData = function(pos, data) {
  console.log('debug', 'split.js reload');

  var self = this;
  if (!data.room_id) {
    $(`.sys_cell_${pos} [name=split_view_date]`).val('');
    $(`.sys_cell_${pos} [name=split_view_place_id]`).val('');
    $(`.sys_cell_${pos} [name=split_view_place]`).val('');
    $(`.sys_cell_${pos}`).css('background-color', '#CCCCCC');
  } else {
    $(`.sys_cell_${pos} [name=split_view_date]`).val(
      util.dataFormat(data.date, 'YYYY/MM/DD')
    );
    $(`.sys_cell_${pos} [name=split_view_place_id]`).val(data.place_id);
    $(`.sys_cell_${pos} [name=split_view_place]`).val(data.name);
    $(`.sys_cell_${pos}`).css('background-color', '#CCCCCC');
  }

  self._canvas[pos].clear();
  self._canvas[pos].backgroundImage = false;
  self._canvas[pos].requestRenderAll();
  self._roomIds[data.room_id] = pos;
  self._splitRoomIds[pos] = data.room_id;
  client.loadMultipleCanvas(data.room_id);
};

// 分割画面の切替
_split.prototype.setItem = function(no, place_id, name, dt) {
  var self = this;

  self._splitInfo[no] = {
    room_id: util.getRoomId(place_id, dt),
    date: dt,
    place_id,
    name,
  };
  self.loadData(no, self._splitInfo[no]);
};

// 分割画面の切替
_split.prototype.goEdit = async function(place_id, name, dt) {
  var self = this;
  var setDate = util.dataFormat(dt, 'YYYY/MM/DD');
  $('[name=hedder_date]').val(setDate);
  places._selectId = place_id;
  places._selectName = name;
  places.reload(dt);
  await places.reloadScaleWhenChangePlace();
  self.setSplit(1);
  $('.sys_cell_edit').css({
    width: '100%',
  });
};

// 場所順・日付順設定
_split.prototype.setOrderBy = function(type) {
  var self = this;

  self._orderBy = type;
  self.reload();
};

_split.prototype.setDummyUuid = function(objs) {
  var self = this;

  if (!objs) {
    return;
  }
  for (let i = 0; i < objs.length; i++) {
    objs[i].uuid = '__dummy__';
    if (objs[i].type == 'egGroup') {
      self.setDummyUuid(objs[i].objects);
    }
  }
};

// 分割画面データ取得
_split.prototype.getSplitInfo = function() {
  var self = this;

  return self._splitInfo;
};

// 分割画面数取得
_split.prototype.getSplitLength = function() {
  var self = this;

  return self._splitNumber;
};

// 前へボタン表示
_split.prototype.showNaviPrev = function() {
  $('.sys_navi_prev')
    .closest('.layout-tool__item')
    .removeClass('pointer-events-none');
};
// 前へボタン非表示
_split.prototype.hideNaviPrev = function() {
  $('.sys_navi_prev')
    .closest('.layout-tool__item')
    .addClass('pointer-events-none');
};

// 次へボタン表示
_split.prototype.showNaviNext = function() {
  $('.sys_navi_next')
    .closest('.layout-tool__item')
    .removeClass('pointer-events-none');
};
// 次へボタン非表示
_split.prototype.hideNaviNext = function() {
  $('.sys_navi_next')
    .closest('.layout-tool__item')
    .addClass('pointer-events-none');
};

// debug用
// eslint-disable-next-line no-unused-vars
_split.prototype.debug = function(str) {
  // console.log(str);
};

_split.prototype.calcMultiSplit = function() {
  $('div.grid-1')
    .find('.layout-canvas')
    .css({
      width: '100%',
    });
  $('.sys_cell_edit').css({
    width: '100%',
  });
  const grid2_4 = $('div.grid-2, div.grid-4');
  const grid6_9 = $('div.grid-6, div.grid-9');
  let isVertical = false;
  if (isIPad()) {
    $('.layout-tool-fix').css({
      width: '123%',
    });
    isVertical = document.body.offsetHeight > document.body.offsetWidth;
  }
  let nextTranformX = 0;
  if ($('#master-navi').hasClass('show')) {
    nextTranformX += 210;
  }
  if ($('#func-navi--item1').hasClass('show')) {
    nextTranformX += 210;
  }
  if (nextTranformX === 0) {
    grid2_4.find('.layout-canvas').css({
      width:
        isIPad() && !isVertical
          ? '45%'
          : isIPad() && isVertical
          ? '38.8%'
          : '50%',
    });
    grid6_9.find('.layout-canvas').css({
      width:
        isIPad() && !isVertical
          ? '27.33%'
          : isIPad() && isVertical
          ? '25.2%'
          : '33.33%',
    });
  }
  if (nextTranformX === 420) {
    grid2_4.find('.layout-canvas').css({
      width: '39%',
    });
    grid6_9.find('.layout-canvas').css({
      width: '27.5%',
    });
  }
  if (isIPad() || nextTranformX === 210) {
    grid2_4.find('.layout-canvas').css({
      width: '45%',
    });
    grid6_9.find('.layout-canvas').css({
      width: '30.33%',
    });
    if (isVertical) {
      grid2_4.find('.layout-canvas').css({
        width: '38.8%',
      });
      grid6_9.find('.layout-canvas').css({
        width: '25.2%',
      });
    }
  }
};

export const split = new _split();



// WEBPACK FOOTER //
// ./src/canvas/constructionPlacement/split.js